<div *ngIf="isShowHeader" [ngClass]="{'!overflow-visible': isShowHeader}" class="w-full bg-white overflow-x-hidden">
    <div
        class="rep_header sm:!mb-0 mx-auto w-full max-w-[2500px] px-[clamp(1rem,5vw,10rem)] mb-[2.5rem] flex flex-col gap-[clamp(1rem,3vw,2.5rem)]">

        <!-- Top Bar -->
        <div class="flex justify-end items-center text-sm flex-wrap gap-4 mt-[clamp(1rem,5vw,2rem)]">
            <!-- Currency Dropdown -->
            <div class="relative w-32">
                <span
                    class="block w-full px-3 py-2 text-sm text-gray-700 bg-white rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition duration-200">EUR</span>
            </div>
        </div>


        <!-- Middle Row -->
        <div class="grid grid-cols-[auto,1fr,auto] items-center gap-5 min-[1200px]:max-[1440px]:gap-4">

            <!-- Logo -->
            <!-- <div class="flex items-center gap-3 flex-shrink-0" (click)="showCategory = true;">
                <img src="../../../../assets/img/SIERA-Logo-New.svg" alt="Logo"
                    class="h-[40px] xl:h-full cursor-pointer" [routerLink]="['/home']" />
            </div> -->

            <div class="flex items-center gap-3 flex-shrink-0" (click)="navigateHome()">
                <img src="../../../../assets/img/SIERA-Logo-New.svg" alt="Logo"
                    class="h-[40px] xl:h-full cursor-pointer" />
            </div>


            <!-- Search (with icons inside the field) -->
       <!-- Search -->
<div class="flex w-full justify-end gap-6">
  <div
    class="flex-1 basis-[clamp(420px,48vw,680px)] max-w-[min(660px,72vw)]
           min-[1200px]:max-[1440px]:basis-[clamp(420px,52vw,640px)]">

    <div
      class="flex items-center p-inputgroup search-group header-search-group
             rounded-xl border border-gray-200 bg-white
             h-[clamp(44px,5vw,56px)] min-[1200px]:max-[1440px]:h-12
             transition-shadow duration-150
             focus-within:shadow-[0_0_0_4px_rgba(59,130,246,.12)]
             focus-within:border-gray-300 overflow-hidden">

      <p-autoComplete
        [(ngModel)]="selectedProduct"
        [suggestions]="filteredProducts"
        [dropdown]="false"
        [minLength]="1"
        [delay]="300"
        placeholder="Search for products..."
        (completeMethod)="onComplete($event)"
        optionLabel="name"
        [appendTo]="'body'"
        [panelStyle]="{
          'z-index': 2147483647,
          'background': '#ffffff',
          'max-height': '200px',
          'overflow': 'hidden'
        }"
        panelStyleClass="ac-panel search-panel"
        class="header-search-autocomplete flex-1 min-w-0"
        inputStyleClass="!h-full !w-full !border-0 !shadow-none !bg-transparent
                         text-[15px] leading-[22px] placeholder:text-gray-400
                         min-[1200px]:max-[1440px]:text-[14px]"
        (input)="sharedService.selectedProduct.set($any($event.target).value)"
        (keyup.enter)="submitSearch()"
        (onSelect)="productRedirection($event)">
      </p-autoComplete>

      <span
        *ngIf="isLoading"
        class="header-search-loading px-2 text-gray-500 shrink-0"
        role="status"
        aria-label="Loading search results">
        <i class="pi pi-spinner pi-spin"></i>
      </span>

      <button
        *ngIf="selectedProduct"
        type="button"
        pButton
        icon="pi pi-times"
        class="p-button-text !px-3 !shadow-none !border-0 !rounded-none !h-full
               shrink-0 text-gray-400 hover:text-gray-700
               min-[1200px]:max-[1440px]:text-[16px]"
        (click)="clearSearch()"
        aria-label="Clear search">
      </button>

      <span
        *ngIf="!selectedProduct"
        pInputGroupAddon
        class="bg-transparent border-0 px-3 shrink-0">
        <i class="pi pi-search text-gray-400 text-[18px]
                  min-[1200px]:max-[1440px]:text-[16px]"></i>
      </span>
    </div>
  </div>
</div>





            <!-- Icons -->
            <div class="flex items-center gap-6 min-[1200px]:max-[1440px]:gap-4 flex-shrink-0 pl-2">
                <div class="relative">
                    <!-- Cart Icon Button -->
                    <p-button (onClick)="showCategory=false;" icon="pi pi-shopping-cart"
                        styleClass="!text-[26px] min-[1200px]:max-[1440px]:!text-[24px] black-color"
                        class="p-button-rounded p-button-text" [routerLink]="['/cart']">
                    </p-button>

                    <!-- Badge -->
                    <span *ngIf="cartItemCount > 0"
                        class="absolute -top-4 -right-3 bg-siera-primary text-white text-sm font-semibold px-2 py-0.5 rounded-full">
                        {{ cartItemCount }}
                    </span>
                </div>

                <div class="relative user-dropdown-container" (click)="dropdownOpen()" tabindex="0">
                    <p-button icon="pi pi-user"
                        styleClass="!text-[26px] min-[1200px]:max-[1440px]:!text-[24px] black-color"
                        class="p-button-rounded p-button-text"></p-button>
                    <div *ngIf="isDropdownOpen && authService.isAuthenticated()"
                        class="absolute right-0 mt-2 bg-white shadow-lg rounded-md z-50">
                        <!-- <a class="block px-4 py-2 hover:bg-gray-100" (click)="dropdownOpen()"
                            [routerLink]="['/buyer-dashboard']">Dashboard</a> -->
                        <a class="block px-4 py-2 hover:bg-gray-100" (click)="ordersNavigate()"
                            [routerLink]="['/orders']">Orders</a>
                        <a class="block px-4 py-2 hover:bg-gray-100" (click)="logout(); dropdownOpen()">Logout</a>
                    </div>
                </div>
            </div>
        </div>

        @if(showCategory || sharedService.showCategory()) {
        <!-- Hamburger Toggle (Mobile) -->
        <div class="md:hidden flex justify-end mb-2">
            <p-button icon="pi pi-bars" class="p-button-text" (click)="toggleMenu()"></p-button>
        </div>
        <!-- Category Menu -->
        <div [ngClass]="{ 'hidden': !isMenuOpen, 'flex': isMenuOpen }"
            class="flex-col md:flex md:flex-row flex-wrap gap-5 pt-4 lg:mb-6 category">
            <div *ngFor="let item of menuItems" class="cursor-pointer flex items-center gap-2 px-3 py-2 xl:px-5 xl:py-3 rounded-3xl hover:bg-siera-gray
                    min-[1200px]:max-[1440px]:px-4 min-[1200px]:max-[1440px]:py-2.5" [ngClass]="{
                'bg-siera-primary text-white': !isHomePage && item.id === activeCategoryId,
                'bg-siera-light-gray': isHomePage || item.id !== activeCategoryId
            }" (click)="setActive(item)">
                <span class="text-[15px] min-[1200px]:max-[1440px]:text-[14px]">{{ item.label }}</span>
                <i *ngIf="item.hasSubcategories" class="pi pi-chevron-down"></i>
            </div>
        </div>
        <!-- Subcategories -->
        <div *ngIf="subcategories.length > 0" class="flex flex-wrap gap-2 mt-2">
            <div *ngFor="let sub of subcategories"
                class="cursor-pointer px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
                (click)="navigateToSubcategory(sub.id)">
                {{ sub.subCategoryName }}
            </div>
        </div>
        }
    </div>
</div>